import React from "react"

import {
    Box,
    Divider,
    List,
    ListItemButton,
    ListItemText,
    Pagination,
    Stack,
    Typography,
} from "@mui/material"
import {
    TabContext,
    TabPanel,
} from "@mui/lab"

import {
    t,
    Trans,
} from "@lingui/macro"

import {
    Action,
    PaginatedResponse,
    PaginationInfo,
    SessionResponse,
} from "models"
import {
    SbTab,
    SbTabList,
} from "components/commons"
import { ActionDetail } from "../action-detail"

interface FirstColumnProps {
    urgent: PaginatedResponse<Action> | null
    sessionData: SessionResponse;
    programmed: PaginatedResponse<Action> | null
    handleCallback: (type: string, id: number) => void
    handlePaginationCallback: (actionType: string, pageId: number) => void
    openDeferDialog: (data: Action) => void
    openMarkAsDone: (data: Action) => void
    openAssignDialog: (data: Action) => void
    openSkipDialog: (data: Action) => void
}
interface FirstColumnState {
    currentTab: string
    selectedCard: string
    selectedCardIndex: number
    urgentPageId: number
    programmedPageId: number
    deferAction: Action | null
}


export class FirstColumn extends React.Component<FirstColumnProps, FirstColumnState> {
    constructor(props: FirstColumnProps) {
        super(props)
        this.state = {
            currentTab: "1",
            selectedCard: "URGENT",

            selectedCardIndex: 0,
            urgentPageId: this.props.urgent ? this.props.urgent.pagination.currentPage : 0,
            programmedPageId: this.props.programmed ? this.props.programmed.pagination.currentPage : 0,
            deferAction: null,
        }
    }

    private handleSelectUrgent = (index: number) => {
        if (!this.props.urgent) {
            return
        }

        this.setState(() => ({
            selectedCard: "URGENT",
            selectedCardIndex: index,
        }),
            () => (this.props.handleCallback(
                this.state.selectedCard as string,
                this.state.selectedCardIndex as number,
            )),
        )
    }

    private handleSelectProgrammed = (index: number) => {
        if (!this.props.programmed) {
            return
        }

        this.setState(() => ({
            selectedCard: "PROGRAMMED",
            selectedCardIndex: index,
        }),
            () => (this.props.handleCallback(
                this.state.selectedCard as string,
                this.state.selectedCardIndex as number,
            )),
        )
    }

    private handleUrgentPagination = (_: any, value: number) => {
        this.setState(() => ({
            programmedPageId: 0,
            urgentPageId: value
        }), () => (this.props.handlePaginationCallback("URGENT", value)))
    }

    private handleProgrammedPagination = (_: any, value: number) => {
        this.setState(() => ({
            programmedPageId: value,
            urgentPageId: 0,
        }), () => (this.props.handlePaginationCallback("PROGRAMMED", value)))
    }

    private onTabChange = (_: any, newValue: string) => {
        this.setState(() => ({ currentTab: newValue }))
    }

    render() {
        const urgentPagination: PaginationInfo | undefined = this.props.urgent?.pagination
        const programmedPagination: PaginationInfo | undefined = this.props.programmed?.pagination

        return (
            <TabContext value={this.state.currentTab}>
                <Box sx={{ borderBottom: 0 }}>
                    <SbTabList
                        variant="fullWidth"
                        onChange={this.onTabChange}>
                        <SbTab
                            label={t({ id: "actions.next-actions", message: "Azioni da fare", })}
                            value="1" />
                        <SbTab
                            label={t({ id: "actions.future-actions", message: "Azioni future", })}
                            value="2" />
                    </SbTabList>
                </Box>
                <TabPanel value="1" sx={{ px: 0, }}>
                    {this.props.urgent && this.props.urgent.items.length !== 0 &&
                        <Stack direction="column" alignItems="center" height="50vh">
                            <Pagination
                                showFirstButton
                                showLastButton
                                page={(urgentPagination?.currentPage ?? 0) + 1}
                                count={urgentPagination?.totalPages ?? 1}
                                onChange={this.handleUrgentPagination} />
                            <List sx={{ width: "100%", overflow: "auto" }}>
                                {this.props.urgent.items.map((data: Action, index: number) => (
                                    <Box key={data.id}>
                                        <ListItemButton
                                            onClick={() => this.handleSelectUrgent(index)}
                                            selected={this.state.selectedCard === "URGENT" && this.state.selectedCardIndex === index}>
                                            <ActionDetail data={data}
                                                sessionData={this.props.sessionData}
                                                openDeferDialog={() => this.props.openDeferDialog(data)}
                                                openMarkAsDone={() => this.props.openMarkAsDone(data)}
                                                openAssignDialog={() => this.props.openAssignDialog(data)}
                                                openSkipDialog={() => this.props.openSkipDialog(data)}
                                            />
                                        </ListItemButton>
                                        <Divider />
                                    </Box>
                                ))}
                            </List>
                        </Stack>
                    }
                    {(this.props.urgent?.items.length ?? 0) === 0 &&
                        <Typography pt={5} textAlign="center" height="50vh">
                            <Trans id="actions.no-actions">
                                Nessuna azione trovata
                            </Trans>
                        </Typography>
                    }

                </TabPanel>
                <TabPanel value="2" sx={{ px: 0, }}>
                    {this.props.programmed && this.props.programmed.items.length !== 0 &&
                        <Stack direction="column" alignItems="center" height="50vh">
                            <Pagination
                                showFirstButton
                                showLastButton
                                page={(programmedPagination?.currentPage ?? 0) + 1}
                                count={programmedPagination?.totalPages ?? 1}
                                onChange={this.handleProgrammedPagination} />
                            <List sx={{ width: "100%", overflow: "auto" }}>
                                {this.props.programmed.items.map((data: Action, index: number) => (
                                    <ListItemButton
                                        key={data.id}
                                        onClick={() => this.handleSelectProgrammed(index)}
                                        selected={this.state.selectedCard === "PROGRAMMED" && this.state.selectedCardIndex === index}>
                                        <ListItemText>
                                            <ActionDetail data={data}
                                                sessionData={this.props.sessionData}
                                                openDeferDialog={() => this.props.openDeferDialog(data)}
                                                openMarkAsDone={() => this.props.openMarkAsDone(data)}
                                                openAssignDialog={() => this.props.openAssignDialog(data)}
                                                openSkipDialog={() => this.props.openSkipDialog(data)}
                                            />
                                        </ListItemText>
                                    </ListItemButton>
                                ))}
                            </List>
                        </Stack>
                    }
                    {(this.props.programmed?.items.length ?? 0) === 0 &&
                        <Typography pt={5} textAlign="center" height="50vh">
                            <Trans id="actions.no-actions">
                                Nessuna azione trovata
                            </Trans>
                        </Typography>
                    }
                </TabPanel>
            </TabContext>
        )
    }
}
